/**
 * Formats a campaign type string from snake_case or kebab-case to Title Case
 * @param {string|string[]} type - The campaign type string or array to format
 * @returns {string} - The formatted campaign type string
 */
export const formatCampaignType = (type) => {
  if (!type || type === "-") return "-";

  // Handle array input - use the first element if it's an array
  const typeString = Array.isArray(type) ? type[0] : type;

  // If after array handling we still don't have a valid string, return "-"
  if (!typeString || typeString === "-") return "-";

  // Special case handling
  if (typeString === "page-content") {
    return "Content List";
  }
  if (typeString === "banner-content") {
    return "Banners";
  }
  if (typeString === "survey-quiz-content") {
    return "Surveys & Quizzes";
  }

  // Ensure typeString is actually a string before calling string methods
  if (typeof typeString !== "string") return "-";

  // Replace both underscores and hyphens with spaces, then split
  return typeString
    .replace(/[_-]/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

/**
 * Formats a profile address object into a comma-separated string
 * @param {Object} item - The item containing profile.contact.addresses
 * @returns {string} - The formatted address string or "-"
 */
export const formatAddress = (item) => {
  const addresses =
    item.profile?.contact?.addresses !== null
      ? item.profile?.contact?.addresses?.[0]
      : {};
  const formattedStreetTwo = addresses?.streetTwo
    ? addresses?.streetTwo === "NA"
      ? "-"
      : addresses?.streetTwo
    : "";
  const addressParts = [
    addresses?.street,
    formattedStreetTwo,
    addresses?.city,
    addresses?.stateProvince,
    addresses?.postalCode,
  ].filter((v) => v !== undefined && v !== null && `${v}`.trim() !== "");
  return addressParts.length ? addressParts.join(", ") : "-";
};
